import { readFromStorage } from '../../shared/utils/storage.utils';


export interface ZitadelUserDetail {
  email?: string;
  sub?: string;
  business_unit?: string;
  [key: string]: unknown;
}


const DEV_BUSINESS_UNIT = 'MS-US';

interface StoredUser {
  _id?: string;
  id?: string;
  zitadel_user_id?: string;
  zitadelUserId?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  [key: string]: unknown;
}

export function readStoredUser(): StoredUser | null {
  try {
    return JSON.parse(readFromStorage('user') ?? 'null') as StoredUser | null;
  } catch {
    return null;
  }
}

function readSsoClaims(): ZitadelUserDetail | null {
  try {
    const parsed = JSON.parse(readFromStorage('userDetail') ?? 'null') as ZitadelUserDetail | null;
    return parsed && parsed.sub ? parsed : null;
  } catch {
    return null;
  }
}

export function identityFromUser(user: StoredUser): ZitadelUserDetail | null {
  const sub = user.zitadel_user_id ?? user.zitadelUserId;
  if (!sub && !user.email) return null;
  const name =
    user.full_name ??
    (`${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() || undefined);
  return {
    ...(user.email ? { email: user.email } : {}),
    ...(sub ? { sub: String(sub) } : {}),
    ...(name
      ? { name, given_name: user.first_name, family_name: user.last_name }
      : {}),
  };
}

export function getUserIdentity(): ZitadelUserDetail {
  const user = readStoredUser();
  const detail: ZitadelUserDetail =
    readSsoClaims() ?? (user && identityFromUser(user)) ?? {};

  const bu = getBusinessUnit();
  if (bu) detail.business_unit = bu;
  return detail;
}

export function getBusinessUnit(): string {
  return readFromStorage('business-unit') ?? DEV_BUSINESS_UNIT;
}
